module.exports = __webpack_public_path__ + "img/img-floor-3f.d9f8456b.png";